import React from 'react'
import Home from './home/home.jsx'
import Header from './header/header.jsx'
import Footer from './footer/footer.jsx'
import Service from './services/services.jsx'
import About from './about/about.jsx'
import {BrowserRouter,Routes,Route} from 'react-router-dom'
import Imagemove from './imgswitch.jsx'
import Cal from './cal/cal.jsx'
import Loc from './location/location.jsx'
import Contact from './contact/contact.jsx'
import Product from './product/product.jsx'
import Chats from './chat/chat.jsx'
import Cer from './cer.jsx'
import Appoinment from './appoinment/appoinment.jsx'
export default function App() {
  return (
    <div>
      <BrowserRouter>
      <Header/>
        <Routes>
          <Route path='/' element={<>  <Imagemove/><Home/><Cer/>  </>}/>
          <Route path='/about' element={<About/>}/>
          <Route path='/services' element={<Service/>}/>
          <Route path='/cal' element={<Cal/>}/>
          <Route path='/loc' element={<Loc/>}/>
          <Route path='/cont' element={<Contact/>}/>
          <Route path='/products' element={<Product/>}/>
          <Route path='/chat' element={<Chats/>}/>
          <Route path='/appoint' element={<Appoinment/>}/>
        </Routes>
      <Footer/>
      </BrowserRouter>
    </div>
  )
}
